import type { Nasheed } from '../types';

export const nasheeds: Nasheed[] = [
  {
    id: 'i-look-i-see',
    title: 'I Look I See',
    category: 'Kindness',
    artwork: 'rainbow',
    provider: 'YouTube: I Look I See',
    url: 'https://www.youtube.com/watch?v=Oz1PUlrMoig',
  },
  {
    id: 'months-islam',
    title: 'Months of Islam',
    category: 'Calendar',
    artwork: 'moon',
    provider: 'YouTube: Months of Islam',
    url: 'https://www.youtube.com/watch?v=8TXZDWHR4R0&list=RD8TXZDWHR4R0&start_radio=1',
  },
  {
    id: 'names-allah',
    title: '99 Names of Allah',
    category: 'Aqidah',
    artwork: 'star',
    provider: 'Kids nasheed',
    url: 'https://www.youtube.com/watch?v=4bi3ZyB9itY',
  },
  {
    id: 'arabic-alphabet',
    title: 'Arabic Alphabet',
    category: 'Arabic',
    artwork: 'arabic',
    provider: 'Zaky nasheed',
    url: 'https://www.youtube.com/watch?v=6e145BWP7ng',
  },
  {
    id: 'ramadan-nasheed',
    title: 'Ramadan Nasheed',
    category: 'Ramadan',
    artwork: 'lantern',
    provider: 'MiniMuslims',
    url: 'https://www.youtube.com/watch?v=4VpiuY_C5Ok',
  },
];
